export default __webpack_public_path__ + "static/media/slide1_title.a963ab70.png";